import FA from 'actions/fsdo/fsdoFsdoActions';
import { RSAA } from 'redux-api-middleware';
import moment from 'moment';

export const 
fsdoUpdateStateSelectOptions = f => ({ type: FA.UPDATE_FSDO_STATE_OPTIONS, payload: f }),
fsdoLoadFsdoLocations = () => ({ [RSAA]: {
    method: 'GET',
    endpoint: '/user/org/fsdo',
    types: [
        FA.GET_FSDO_LOCATIONS_PENDING,
        FA.GET_FSDO_LOCATIONS_SUCCESS,
        FA.GET_FSDO_LOCATIONS_FAILURE
    ]
}}),

fsdoLoadRequestReset = () => ({ type: FA.RESET_FSDO_LOAD_REQUEST }),

fsdoSubmit = data => {
    data = JSON.stringify({
        timeStamp: moment().unix(),
        originatingSystem: "SS-Admin-Service",
        messageUuid: "9dc02909-7597-4faf-a939-788c177d3f3a",
        ssUser: {
            userName: null,
            password: null,
            personalInformation: {
                firstName: data.firstName === '' ? null : data.firstName.trim(),
                lastName: data.lastName === '' ? null : data.lastName.trim(),
                middleName: data.middleName === '' ? null : data.middleName.trim(),
                nameSuffix: null,
                dateOfBirth: null,
                dateOfBirthType: null,
                passportType: null,
                passportNumber: null,
                passportIssueDate: null,
                expirationDate: null,
                issuingCountry: null,
                city: null
            },
            fsdoInformation: {
                fsdoName: data.fsdo,
                fsdoRegion: data.fsdoState
            },
            userRoles: [{
                role: 'FSDO',
                population: 'AFSP'
            }],
            securityQuestions: [],
            contactInformation: [{
                contactType: 'EMAIL',
                contactValue: data.emailAddress
            }, {
                contactType: 'PHONE_NUMBER',
                contactValue: data.phoneNumber.trim()
            }]
        }
    });

    return { [RSAA]: {
        method: 'POST',
        endpoint: '/user',
        headers: { 'Content-Type': 'application/json' },
        body: data,
        types: [
            FA.FSDO_SUBMISSION_PENDING,
            FA.FSDO_SUBMISSION_SUCCESS,
            FA.FSDO_SUBMISSION_FAILURE
        ]
    }}
},

fsdoResetSubmissionRequest = () => ({ type: FA.FSDO_RESET_SUBMISSION_REQUEST }),
fsdoToggleSubmitView = () => ({ type: FA.FSDO_TOGGLE_SUBMIT_VIEW }),
changeFsdoValidationStep = s => ({ type: FA.FSDO_CHANGE_VALIDATION_STEP, payload: s }),
resetFsdoSubmission = () => ({ type: FA.FSDO_RESET_SUBMISSION }),
fsdoToggleModal = () => ({ type: FA.FSDO_TOGGLE_SUBMISSION_MODAL }),
fsdoUpdateModalContent = c => ({ type: FA.FSDO_UPDATE_MODAL_CONTENT, payload: c }),
fsdoUpdateModalProps = p => ({ type: FA.FSDO_UPDATE_MODAL_PROPS, payload: p });